import { useContext, useEffect, useState } from "react";
import { Flex, useColorModeValue, Spinner, Box } from "@chakra-ui/react";
import Navbar from "./Navbar";
import Main from "./Main";
import Footer from "./Footer";
import { AppContext } from "AppProvider/AppContext";
import DocumentsTable from "App/BsesPoc/components/DocumentTable";
import Dashboard from "App/BsesPoc/components/Dashboard";
import BsesUsersPage from "App/BsesPoc/components/Users/BsesUsersPage";
import BsesRoles from "App/BsesPoc/components/Roles/BsesRoles";
import WorkFlow from "App/WorkFlow";
import Approvals from "App/BsesPoc/components/Approvals/Approvals";
import CureBay from "App/CureBay";
import DynamicForm from "App/Onboarding/DynamicForm";
import AddWord from "App/WorkFlow/component/AddWord/AddWord";
import { routePath } from "config/pathConstant";
import FormTable from "App/Onboarding/FormTable/FormTable";
import Reports from "App/BsesPoc/components/Reports/Reports";
import MmtDashboardIndex from "App/BsesPoc/components/Dashboard/MtDashboardIndex";
import MtApprovals from "App/BsesPoc/components/MtApprovals/MtApprovals";
import DuplicateDocument from "App/BsesPoc/components/Approvals/component/duplicateDocument/DuplicateDocument";
import InitiateDocument from "App/BsesPoc/components/Approvals/component/InitiateDocument/InitiateDocument";
import TaxCodes from "App/BsesPoc/components/TaxCodes/TaxCodes";
import PaymentInitiateDocument from "App/BsesPoc/components/Approvals/component/paymentInitiateDocument/PaymentInitiateDocument";
import FileMasterData from "App/BsesPoc/components/FileMastersData/FIleMasterData";
import SapXmlPayload from "App/BsesPoc/components/SapXmlPayload/SapXmlPayload";
import ForeignEstimate from "App/BsesPoc/components/ForeignEstimate/ForeignEstimate";
import CostCenter from "App/BsesPoc/components/Master/CostCenter/CostCenter";
import ForeignBank from "App/BsesPoc/components/Master/ForeignBank/ForeignBank";
import DocumentUploadTab from "App/BsesPoc/components/foreignProcess/DocumentUploadTab";
import ForeignAdminTools from "App/BsesPoc/components/foreignProcess/ForeignAdminTools";
import EmergingAdminTools from "App/BsesPoc/components/emergingProcess/EmergingAdminTools";
import EmergingRegion from "App/BsesPoc/components/Master/EmergingRegion/EmergingRegion";
import PrFiUser from "App/BsesPoc/components/Master/PrFiUser/PrFiUser";


type setActivePage = React.Dispatch<React.SetStateAction<string>>;

type Page = {
  name: string;
  element: JSX.Element;
  appBar: boolean;
};

export default function MainWindow({
  activePage,
  setActivePage,
  displaySidebar,
  setDisplaySidebar,
  setOpenMobileSideDrawer,
  workFlowData,
}: {
  activePage: string;
  setActivePage: setActivePage;
  displaySidebar: boolean;
  setOpenMobileSideDrawer: any;
  setDisplaySidebar: React.Dispatch<React.SetStateAction<boolean>>;
  workFlowData?: any;
}): JSX.Element {
  const { companyType, accountDetails } = useContext(AppContext);
  const [pages, setPages] = useState<Page[]>([]);

  // 🧠 Build the page list dynamically when processName or accountDetails change
  useEffect(() => {
    const basePages: Page[] = [
      {
        name: routePath.Dashboard,
        element:
          workFlowData?.processName?.toLowerCase() === "mmt" ? (
            <MmtDashboardIndex />
          ) : (
            <Dashboard />
          ),
        appBar: true,
      },
      {
        name: routePath.Approvals,
        element:
          workFlowData?.processName?.toLowerCase() === "mmt" ? (
            <MtApprovals />
          ) : (
            <Approvals />
          ),
        appBar: true,
      },
      {
        name: routePath.Reports,
        element: <Reports />,
        appBar: true,
      },
      {
        name: routePath.pendingApproval,
        element: (
          <DocumentsTable
            name={routePath.pendingApproval}
            type="pending"
            activePage={activePage}
            isDisabled={false}
            isManual={true}
          />
        ),
        appBar: true,
      },
      {
        name: routePath.fileMasterData,
        element: (
          <FileMasterData
          />
        ),
        appBar: true,
      },

      // ✅ Duplicate page only if NOT MMT
      {
        name: routePath.duplicate,
        element:
          workFlowData?.processName?.toLowerCase() !== "mmt" ? (
            <DuplicateDocument
              name={routePath.duplicate}
              type="pending"
              activePage={activePage}
              isDisabled={false}
              isManual={true}
            />
          ) : (
            <></>
          ),
        appBar: workFlowData?.processName?.toLowerCase() !== "mmt",
      },
      {
        name: routePath.initiateDocument,
        element:
          workFlowData?.processName?.toLowerCase() !== "mmt" ? (
            <InitiateDocument
              name={routePath.initiateDocument}
              type="pending"
              activePage={activePage}
              isDisabled={false}
              isManual={true}
            />
          ) : (
            <></>
          ),
        appBar: workFlowData?.processName?.toLowerCase() !== "mmt",
      },
      {
        name: routePath.paymentInitiateDocument,
        element:
          workFlowData?.processName?.toLowerCase() !== "mmt" ? (
            <PaymentInitiateDocument
            // name={routePath.paymentInitiateDocument}
            // type="pending"
            // activePage={activePage}
            // isDisabled={false}
            // isManual={true}
            />
          ) : (
            <></>
          ),
        appBar: workFlowData?.processName?.toLowerCase() !== "mmt" && workFlowData?.processName?.toLowerCase() === "foreign",
      },
      {
        name: routePath.ForeignBankMaster,
        element:
          workFlowData?.processName?.toLowerCase() !== "mmt" ? (
            <ForeignBank
            // name={routePath.paymentInitiateDocument}
            // type="pending"
            // activePage={activePage}
            // isDisabled={false}
            // isManual={true}
            />
          ) : (
            <></>
          ),
        appBar: workFlowData?.processName?.toLowerCase() !== "mmt" && workFlowData?.processName?.toLowerCase() === "foreign",
      },
      {
        name: routePath.foreignDocumentUpload,
        element: <DocumentUploadTab />,
        appBar: true,
      },
      {
        name: routePath.sapXMLPayload,
        element:
          <SapXmlPayload
          />,
        appBar: true,
      },
      {
        name: routePath.foreignAdminTools,
        element: <ForeignAdminTools />,
        appBar: true,
      },
      {
        name: routePath.emergingRegion,
        element: <EmergingRegion />,
        appBar: true,
      },
      {
        name: routePath.curbayTable,
        element: <CureBay />,
        appBar: true,
      },
      {
        name: routePath.Onboarding,
        element: <DynamicForm />,
        appBar: true,
      },
      {
        name: routePath.Form,
        element: <FormTable />,
        appBar: true,
      },
      {
        name: routePath.Approved,
        element: (
          <DocumentsTable
            name={routePath.Approved}
            type="approved"
            activePage={activePage}
            isDisabled={true}
            isManual={true}
          />
        ),
        appBar: true,
      },
      {
        name: routePath.Rejected,
        element: (
          <DocumentsTable
            name={routePath.Rejected}
            type="rejected"
            activePage={activePage}
            isDisabled={true}
            isManual={false}
          />
        ),
        appBar: true,
      },
      {
        name: routePath.Users,
        element: <BsesUsersPage />,
        appBar: true,
      },
      {
        name: routePath.Permissions,
        element: <BsesRoles />,
        appBar: true,
      },
    ];

    // admin pages
    if (
      accountDetails &&
      (accountDetails?.userType === "admin" || accountDetails?.role === "admin")
    ) {
      basePages.push({
        name: routePath.WorkFlow,
        element: <WorkFlow />,
        appBar: true,
      });

      basePages.push({
        name: routePath.TaxCodes,
        element: <TaxCodes />,
        appBar: true,
      });

      basePages.push({
        name: "Foreign Estimate",
        element: <ForeignEstimate />,
        appBar: true,
      });

      basePages.push({
        name: routePath.CostCenter,
        element: <CostCenter />,
        appBar: true,
      });

      basePages.push({
        name: routePath.ForeignBankMaster,
        element: <ForeignBank />,
        appBar: true,
      });
      basePages.push({
        name: routePath.PrFiUserMapping,
        element: <PrFiUser />,
        appBar: true,
      });

    }

    // AddWord for level-1
    if (accountDetails && accountDetails?.level === "level-1") {
      basePages.push({
        name: routePath.addWord,
        element: <AddWord />,
        appBar: true,
      });
    }

    setPages(basePages);
  }, [workFlowData?.processName, accountDetails, activePage]);


  const currentPage = () => {
    const current = pages.find((p) => p.name === activePage);
    return current ? current.element : null;
  };

  return (
    <Flex
      bg={useColorModeValue("gray.1000", "gray.500")}
      direction="column"
      w="full"
    >
      <Navbar
        activePage={activePage}
        setActivePage={setActivePage}
        displaySidebar={displaySidebar}
        setDisplaySidebar={setDisplaySidebar}
        setOpenMobileSideDrawer={setOpenMobileSideDrawer}
      />

      {companyType ? (
        <Box
          w={{
            base: "100%",
            lg: displaySidebar ? "calc(100% - 4rem)" : "100%",
          }}
          ml={{ base: "unset", lg: displaySidebar ? "4rem" : "0" }}
        >
          <Main>{currentPage()}</Main>
        </Box>
      ) : (
        <Flex
          justifyContent="center"
          alignItems="center"
          p={6}
          ps={12}
          pe={12}
          minH="calc(100vh - 140px)"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="teal.500"
            size="xl"
          />
        </Flex>
      )}

      <Footer displaySidebar={displaySidebar} activePage={activePage} />
    </Flex>
  );
}